<template>
  <div class="x-tablelist-view" data-automation="shortMessage">
    <!-- 搜索行 -->
    <ux-searchOption
      :layout="layout"
      :data="filter"
      @search="search"
      @input="search"
      @clear="clear"
    ></ux-searchOption>
    <!-- 表格 -->
    <div class="x-table-box">
      <ux-table
        ref="table"
        maxHeight="100%"
        :hide-on-single-page="true"
        :data="tableData.list"
        :columns="columns"
        :total="tableData.totalSize"
        :size.sync="filter.size"
        :page.sync="filter.page"
        @changePage="changePage"
        @changeSize="changeSize"
        :emptyText="$t('HT.nodata')"
        layout="total, sizes, prev, pager, next"
      ></ux-table>
    </div>
  </div>
</template>
<script>
import imeiInput from '../template/imeiInput';
export default {
  data() {
    return {
      layout: [
        // 搜索项配置
        {
          width: '220px',
          render: (h) => {
            return h(imeiInput, {
              props: {
                value: this.filter.imeis
              },
              on: {
                change: (val) => {
                  this.filter.imeis = val;
                }
              }
            });
          }
        },
        {
          width: '220px',
          render: (h) => {
            return h(imeiInput, {
              props: {
                value: this.filter.imeis,
                placeholder: this.$t('HT.realDataManage.iccid.placeholder')
              },
              on: {
                change: (val) => {
                  this.filter.imeis = val;
                }
              }
            });
          }
        },
        {
          type: 'select',
          key: 'reason',
          options: [],
          placeholder: this.$t('HT.realDataManage.reason.placeholder')
        },
        {
          type: 'button',
          text: this.$t('HT.search1'),
          show: true,
          event: 'search'
        },
        {
          type: 'button',
          text: this.$t('HT.clear'),
          plain: true,
          show: true,
          event: 'clear'
        },
        {
          type: 'button',
          text: this.$t('HT.deviceManage.exportData'),
          show: true,
          right: true,
          event: 'clear'
        }
      ],
      columns: [
        // 表头数据
        {
          label: 'IMEI',
          prop: 'imei',
          tooltip: true
        },
        {
          label: this.$t('HT.upgrade.versions'),
          prop: 'version',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.singlechipVersionr'),
          prop: 'singlechip_version',
          tooltip: true,
          width: 90
        },
        {
          label: 'MCU',
          prop: 'mcu',
          tooltip: true
        },
        {
          label: 'CSQ',
          prop: 'csq',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.selfTestPower'),
          prop: 'self_test_power',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.wakeupNum'),
          prop: 'wakeup_num',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.workModel'),
          prop: 'work_model',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.temperature'),
          prop: 'temperature',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.actualElectricity'),
          prop: 'actual_electricity',
          tooltip: true
        },
        {
          label: this.$t('HT.realTimeLog.activationTime'),
          prop: 'create_time',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.lastLogin'),
          prop: 'last_login',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.offlineDays'),
          prop: 'offline_days',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.updateLog'),
          prop: 'update_log',
          tooltip: true
        },
        {
          label: 'Iccid',
          prop: 'Iccid',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.server'),
          prop: 'server',
          tooltip: true
        },
        {
          label: 'IP',
          prop: 'ip',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.externalVoltage'),
          prop: 'external_voltage',
          tooltip: true
        },
        {
          label: this.$t('HT.realDataManage.offlineMessage'),
          prop: 'offline_message',
          tooltip: true
        }
      ],
      filter: {
        // 查询参数
        imei: '', // imei号
        serial_num: '',
        page: 1,
        size: 10
      },
      tableData: {
        // 表格数据
        totalSize: 0,
        list: []
      }
    };
  },
  created() {
    // this.getList(this.filter);
  },
  methods: {
    /**
     * 获取列表
     * @param {Object} params 请求参数
     */
    getList(params) {
      this.$uxLoading.show();
      this.$api.message.getSign(params).then((res) => {
        if (res.code == 10000) {
          this.tableData = {
            totalSize: res.total_size,
            list: res.data
          };
        }
      });
    },

    /**
     * 点击搜索
     */
    search() {
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 点击搜索
     */
    clear() {
      this.filter = {};
    },
    /**
     * 改变页容量
     * @param {Number} size 选择的页容量
     */
    changeSize(size) {
      this.filter.size = size;
      this.filter.page = 1;
      this.getList(this.filter);
    },
    /**
     * 改变页码
     * @param {Number} page 选择的页码
     */
    changePage(page) {
      this.filter.page = page;
      this.getList(this.filter);
    }
  }
};
</script>
<style lang="scss" scope>
.export-button {
  margin-bottom: 20px;
  width: 140px;
  text-align: right;
}
</style>
